import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeedbackUsuario } from '../feedback-usuario/feedback-usuario.model';
import { environment } from 'src/environments/environment';

const API = environment.apiProfessor;

@Injectable({
  providedIn: 'root',
})
export class FeedbackUsuarioService {
  constructor(private http: HttpClient) {}

  getFeedback(cpf: string): Observable<FeedbackUsuario[]> {
    return this.http.get<FeedbackUsuario[]>(`${API}/login?`, {
      params: {
        TIPO: 'AVALIACAO_USUARIO',
        CPF: cpf,
      },
    });
  }

  submitFeedback(
    cpf: string,
    mensagem: string,
    nota: number,
  ): Observable<unknown> {
    const json = `[{"CPF":"${cpf}","MENSAGEM":"${mensagem}","NOTA":${nota}}]`;

    return this.http.post(`${API}/login?`, json, {
      headers: {
        JSON: json,
      },
      params: {
        TIPO: 'AVALIACAO_USUARIO',
        CPF: cpf,
      },
    });
  }
}
